import axios from 'axios'
import router from "@/router";
import globalData from "../global";
import {Notification} from 'element-ui';

const request = axios.create({
  baseURL: `${globalData.serverIp}`,
  timeout: 30000,
})

request.interceptors.request.use(config => {
  config.headers['Content-Type'] = config.contextType?config.contextType:'application/json';
  config.headers['token'] = localStorage.getItem("token");
  return config
}, error => {
  return Promise.reject(error)
});

request.interceptors.response.use(response => {
  let res = response.data
  if (res.status !== 1) {
    Notification({type: 'error', title: 'Operation failed', message: res.msg})
    if (res.status === -2) {
      localStorage.removeItem("token")
      router.replace("/login").then(r => {})
    }
  }
  return res
}, error => {
  if (error.code === 'ECONNABORTED' || error.message.includes("timeout")) {
    Notification({type: 'error', title: 'Request timeout', message: 'Network is slow, please retry'})
  } else if (error.message === "Network Error") {
    Notification({type: 'error', title: 'Network error', message: 'Network error, please refresh and retry'})
  } else {
    Notification({type: 'error', title: 'Error', message: error.message})
  }
  return Promise.reject(error)
});

export default request;